import { type User, UserRoleType } from '@omnipresentgroup/types';

export const DEFAULT_EMPLOYEE_USER: User = {
  userId: '82e11408-5cd4-4ce1-8d54-73622f4930b5',
  authId: 'auth0|6348088d0913a31d51a3a763',
  firstName: 'Roy Testing Sr.',
  lastName: 'Testertonww',
  displayName: 'Roy',
  name: 'Roy Testerton',
  email: 'e2e-employee@omnie2etesting.com',
  roles: [
    {
      tenantId: 'adc8745b-f6fa-48a7-82f0-cf82ecd8b7t4',
      type: UserRoleType.EMPLOYEE,
      id: 'def2967b-f6fa-48a7-82f0-cf56ecd8b5a7',
    },
  ],
  seenWelcomeScreen: false,
  seenPrivacyPolicy: '2023-06-14T11:16:16.221Z',
  updatedBy: 'auth0|6348088d0913a31d51a3a763',
  updatedAt: '2023-06-14T11:16:17.509Z',
  createdAt: '2023-06-14T11:16:17.509Z',
  sentInvitationAt: '2023-06-14T11:16:17.509Z',
};

export const DEFAULT_MANAGER_USER: User = {
  userId: 'def2967b-f6fa-48a7-82f0-cf82ecd8b5b3',
  authId: 'auth0|5f06da3e920eff001999e075',
  firstName: 'E2e',
  lastName: 'Manager',
  displayName: 'E2E Manager',
  name: 'E2e Manager',
  email: 'e2e-manager@omnie2etesting.com',
  roles: [
    {
      tenantId: 'adc8745b-f6fa-48a7-82f0-cf82ecd8b7t4',
      id: 'adc8745b-f6fa-48a7-82f0-cf82ecd8b7t4',
      scopes: ['employees:*', 'expenses:notifications'],
      type: UserRoleType.MANAGER,
    },
  ],
  seenWelcomeScreen: false,
  seenPrivacyPolicy: '2021-12-31T01:00:00.000Z',
  updatedBy: 'auth0|6350661c90c345b0acdb93c1',
  updatedAt: '2023-02-09T15:04:16.146Z',
  createdAt: '2023-06-14T11:16:17.509Z',
  sentInvitationAt: '2023-06-14T11:16:17.509Z',
};

export const DEFAULT_REGULAR_MANAGER_USER: User = {
  userId: '83e057be-8168-4101-8d40-29b91a042d31',
  authId: 'auth0|63b6f5858889a650f677eec2',
  firstName: 'E2e',
  lastName: 'Regular Manager',
  displayName: 'E2e Regular Manager',
  name: 'E2e Regular Manager',
  email: 'e2e-regularmgr@omnie2etesting.com',
  roles: [
    {
      tenantId: 'adc8745b-f6fa-48a7-82f0-cf82ecd8b7t4',
      id: 'adc8745b-f6fa-48a7-82f0-cf82ecd8b7t4',
      scopes: ['employees:associated'],
      type: UserRoleType.MANAGER,
    },
  ],
  seenWelcomeScreen: false,
  seenPrivacyPolicy: '2023-01-05T16:08:00.959Z',
  createdAt: '2023-01-05T16:06:29.162Z',
  updatedBy: 'auth0|63b6f5858889a650f677eec2',
  updatedAt: '2023-01-05T16:11:58.482Z',
  sentInvitationAt: '2023-06-14T11:16:17.509Z',
};

export const DEFAULT_ADMIN_USER: User = {
  userId: '7880bcbe-f20e-4d07-bea8-2a2a1ef1ef5b',
  authId: 'auth0|6350661c90c345b0acdb93c1',
  firstName: 'Doesnt',
  lastName: 'Matter',
  displayName: 'Regular Admin',
  name: 'Regular Admin', // TODO: confirm if it's mandatory for admin, and update typings
  email: 'e2e-admin@omnie2etesting.com',
  roles: [
    {
      type: UserRoleType.ADMIN,
      id: '39ffc7d0-9a0f-4cef-b430-f9a89d277b37',
    },
  ],
  seenWelcomeScreen: false,
  seenPrivacyPolicy: '5656565656',
  updatedBy: 'omnihr_user_admin',
  updatedAt: '2022-08-09T14:18:48.257Z',
  createdAt: '2022-08-09T14:18:48.257Z', // TODO: confirm if it's mandatory for admin, and update typings
  sentInvitationAt: '2022-08-09T14:18:48.257Z', // TODO: confirm if it's mandatory for admin, and update typings
};

export const DEFAULT_CONTRACTOR_USER: User = {
  userId: '50647836-ed69-40c0-bec6-bec48c5c2e32',
  authId: 'auth0|6308873ee47ee4ac2b83eda1',
  firstName: 'Test',
  lastName: 'Contractor',
  displayName: 'Test Contractor',
  name: 'Test Contractor',
  email: 'e2e-contractor@omnie2etesting.com',
  roles: [
    {
      tenantId: 'adc8745b-f6fa-48a7-82f0-cf82ecd8b7t4',
      type: UserRoleType.CONTRACTOR,
      id: 'b551a5a1-2641-463f-96a9-1254783a2a48',
    },
  ],
  seenWelcomeScreen: true,
  seenPrivacyPolicy: '2023-06-14T11:16:16.221Z',
  sentInvitationAt: '2022-08-09T14:18:48.257Z',
  createdAt: '2022-08-09T14:18:48.257Z',
};

export const DEFAULT_CS_ADMIN_USER: User = {
  userId: 'cs_user',
  authId: 'auth0|60900ca7bf3ad00070cd4634',
  firstName: 'Doesnt',
  lastName: 'Matterppp',
  displayName: 'Omni Customer Success',
  email: 'e2e-cs@omnie2etesting.com',
  name: 'CS Admin',
  roles: [
    {
      type: UserRoleType.ADMIN,
      id: 'cs_user_admin',
    },
    {
      type: UserRoleType.CS,
    },
  ],
  seenWelcomeScreen: false,
  seenPrivacyPolicy: '5656565656',
  updatedBy: 'auth0|622717161fe166006940ebcc',
  updatedAt: '2022-11-01T19:20:29.697Z',
};

export const createEmployeeUser = (override = {}) => ({
  ...DEFAULT_EMPLOYEE_USER,
  ...override,
});

export const createManagerUser = (override = {}) => ({
  ...DEFAULT_MANAGER_USER,
  ...override,
});

export const createAdminUser = (override = {}) => ({
  ...DEFAULT_ADMIN_USER,
  ...override,
});

export const createContractorUser = (override = {}) => ({
  ...DEFAULT_CONTRACTOR_USER,
  ...override,
});

export const createRegularManagerUser = (override = {}) => ({
  ...DEFAULT_REGULAR_MANAGER_USER,
  ...override,
});

export const createCSAdminUser = (override = {}) => ({
  ...DEFAULT_CS_ADMIN_USER,
  ...override,
});

export const users = {
  employee: createEmployeeUser(),
  manager: createManagerUser(),
  regularManager: createRegularManagerUser(),
  admin: createAdminUser(),
  contractor: createContractorUser(),
  csAdmin: createCSAdminUser(),
};
